export const FETCH_RENAME_DOCUMENTS_REQUEST = 'FETCH_RENAME_DOCUMENTS_REQUEST'
export const FETCH_RENAME_DOCUMENTS_SUCCESS = 'FETCH_RENAME_DOCUMENTS_SUCCESS'
export const FETCH_RENAME_DOCUMENTS_FALUIRE = 'FETCH_RENAME_DOCUMENTS_FALUIRE'
